import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { navLinks, MAILTO } from '../data/content';
export function Navbar() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-hairline bg-white/95 backdrop-blur" data-id="element-83" data-mp="4n1gkapw31us">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between px-5 sm:px-8" data-id="element-84" data-mp="lzg5qk8kjr8">
        <a href="#top" className="rounded-md text-[17px] font-semibold tracking-tight text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-85" data-mp="eh1ki99fq11x">
          ICL Collective
        </a>

        <nav aria-label="Main" className="hidden items-center gap-8 md:flex" data-id="element-86" data-mp="1kyonmdhfuwq7">
          {navLinks.map(link => <a key={link.href} href={link.href} className="rounded-md text-sm font-medium text-ink-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-87" data-mp="9o7v20j25gmv">
              {link.label}
            </a>)}
          <a href={MAILTO} className="whitespace-nowrap rounded-lg bg-accent px-4 py-2 text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-88" data-mp="3n4f8b19jifmn">
            Get in touch
          </a>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="-mr-2 rounded-md p-2 text-ink md:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-89" data-mp="34cw5aufin1km">
          {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-90" data-mp="2wbwz18d9wmob" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-91" data-mp="3azrrcnndcp0v" />}
        </button>
      </div>

      {open && <nav id="mobile-nav" aria-label="Mobile" className="border-t border-hairline bg-white px-5 pb-5 pt-3 md:hidden" data-id="element-92" data-mp="362rsoxsumojs">
          <ul className="space-y-1" data-id="element-93" data-mp="2de416khib2xs">
            {navLinks.map(link => <li key={link.href} data-id="element-94" data-mp="2sabklil3c0c0">
                <a href={link.href} onClick={() => setOpen(false)} className="block rounded-md py-2.5 text-[15px] font-medium text-ink-muted hover:text-ink" data-id="element-95" data-mp="2sbcyduthr0xf">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <a href={MAILTO} onClick={() => setOpen(false)} className="mt-3 block whitespace-nowrap rounded-lg bg-accent px-4 py-2.5 text-center text-sm font-medium text-white hover:bg-accent-hover" data-id="element-96" data-mp="2ndqpdujcqma">
            Get in touch
          </a>
        </nav>}
    </header>;
}